export const AUTOMATION_CANCELLATION_SCHEMA_VERSION = 1 as const;

export const AUTOMATION_CANCELLATION_CODES = {
  DSN_BULLETINS_PENDING_RETRY: 'dsn.bulletins_pending_retry',
  DSN_CONTROL_BLOCKED_RETRY: 'dsn.control_blocked_retry',
  OPERATOR_CANCELLED: 'automation.operator_cancelled',
  DUPLICATE_SUPPRESSED: 'automation.duplicate_suppressed',
  TECHNICAL_INTERRUPTION: 'automation.technical_interruption',
} as const;

export type AutomationCancellationCategory =
  | 'business_prerequisite'
  | 'operator_action'
  | 'deduplicated'
  | 'technical_interruption';

export type AutomationCancellationInitiator = 'system' | 'administrator';

/**
 * Métadonnées non sensibles produites par l'API pour expliquer une annulation.
 * `code` reste ouvert afin qu'une future version du serveur soit affichée comme
 * « à examiner » au lieu d'être interprétée à tort par une ancienne interface.
 */
export interface AutomationCancellationDetails {
  schemaVersion: number;
  code: string;
  category: AutomationCancellationCategory;
  initiatedBy: AutomationCancellationInitiator;
  retryPlanned: boolean;
  requiresAttention: boolean;
}
